import React from 'react';

function Refresh3(props) {
	return (
		<svg height="20" width="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
	<g fill="#000">
		<path d="M17.44 12.21a0.82 0.82 0 0 0-0.11 0.01c-0.51 0.08-0.66 0.51-0.66 0.51a7.19 7.19 0 0 1-6.68 4.48 7.22 7.22 0 0 1-7.22-7.22 0.83 0.83 0 0 0-1.66 0c0 4.9 3.98 8.88 8.88 8.88a8.84 8.84 0 0 0 6.95-3.36l0.13 0.91c0.06 0.46 0.49 0.77 0.94 0.72a0.83 0.83 0 0 0 0.71-0.94l-0.45-3.27a0.83 0.83 0 0 0-0.83-0.72z" fill="#000" opacity="0.4"/>
		<path d="M2.54 7.77a0.84 0.84 0 0 0 0.77-0.52 7.19 7.19 0 0 1 6.68-4.47c3.98 0 7.22 3.24 7.22 7.21a0.83 0.83 0 0 0 1.66 0c0-4.9-3.98-8.88-8.88-8.88a8.84 8.84 0 0 0-6.95 3.36l-0.13-0.91a0.84 0.84 0 0 0-0.94-0.72 0.83 0.83 0 0 0-0.71 0.94l0.45 3.27a0.83 0.83 0 0 0 0.83 0.72z" fill="#000"/>
	</g>
</svg>
	);
};

export default Refresh3;